import React from 'react';

const NextMakerApproach = () => {
  const steps = [
    {
      number: "1",
      title: "Découvrir",
      description: "Suivre des modules interactifs en ligne.",
      icon: "📚"
    },
    {
      number: "2",
      title: "Expérimenter",
      description: "Réaliser des mini-projets et ateliers pratiques.",
      icon: "🔬"
    },
    {
      number: "3",
      title: "Co-créer",
      description: "Collaborer avec des tuteurs et mentors locaux et internationaux.",
      icon: "👥"
    },
    {
      number: "4",
      title: "Impacter",
      description: "Finaliser un projet réel, obtenir une certification et accéder à des opportunités concrètes.",
      icon: "🚀"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-title font-bold text-center text-dark-1 mb-12">
          L'Approche <span className="text-blue-2">NextMaker</span>
        </h2>
        
        {/* Version Desktop (timeline horizontale) */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Ligne de la timeline */}
            <div className="absolute top-10 left-0 right-0 h-1 bg-blue-200"></div>
            
            <div className="grid grid-cols-4 gap-8 relative">
              {steps.map((step, index) => (
                <div key={index} className="flex flex-col items-center">
                  {/* Point sur la timeline */}
                  <div className="w-20 h-20 rounded-full bg-white border-4 border-blue-500 flex items-center justify-center shadow-lg z-10">
                    <span className="text-2xl">{step.icon}</span>
                  </div>
                  
                  {/* Contenu */}
                  <div className="text-center mt-6">
                    <div className="text-blue-600 font-bold text-lg mb-2">Étape {step.number}</div>
                    <h3 className="text-normal font-semibold text-dark-1 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Version Mobile (vertical timeline) */}
        <div className="lg:hidden">
          <div className="relative">
            {/* Ligne verticale de la timeline */}
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-1 bg-blue-200 transform md:-translate-x-1/2"></div>
            
            <div className="space-y-12 ml-10 md:mx-auto">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  {/* Point sur la timeline */}
                  <div className="absolute -left-12 md:-left-10 top-2 w-10 h-10 rounded-full bg-white border-4 border-blue-500 flex items-center justify-center shadow-lg z-10">
                    <span className="text-sm">{step.icon}</span>
                  </div>
                  
                  {/* Contenu */}
                  <div className="bg-white p-6 rounded-lg shadow-md">
                    <div className="text-blue-600 font-bold text-sm mb-1">Étape {step.number}</div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextMakerApproach;